import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { UserPlus, Loader2 } from "lucide-react";
import { api, fmtErr } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AcceptInvite() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { user, loading, refresh } = useAuth();
  const [status, setStatus] = useState("checking"); // checking | need_login | accepting | done | error
  const [error, setError] = useState("");

  useEffect(() => {
    if (loading) return;
    if (!user) { setStatus("need_login"); return; }
    (async () => {
      setStatus("accepting");
      try {
        await api.post("/team/invite/accept", { token });
        if (refresh) await refresh();
        setStatus("done");
        toast.success("Convite aceito!");
        setTimeout(() => navigate("/dashboard"), 1500);
      } catch (err) {
        setStatus("error");
        setError(fmtErr(err.response?.data?.detail) || "Erro ao aceitar convite");
      }
    })();
  }, [loading, user, token, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "var(--bg)" }} data-testid="accept-invite-page">
      <div className="card p-8 max-w-md text-center">
        <div className="inline-flex w-14 h-14 rounded-full grad-bg items-center justify-center mb-4">
          <UserPlus size={26} className="text-white" />
        </div>
        <h1 className="text-2xl font-extrabold mb-2">Convite Social Booster</h1>
        {status === "checking" || status === "accepting" ? (
          <div className="flex items-center justify-center gap-2 text-sm text-muted">
            <Loader2 size={14} className="animate-spin" /> Processando convite…
          </div>
        ) : status === "need_login" ? (
          <div>
            <p className="text-sm text-muted mb-4">Você precisa estar logado (com o e-mail convidado) para aceitar.</p>
            <button
              onClick={() => { localStorage.setItem("sb_pending_invite", token); navigate("/login"); }}
              className="btn-grad text-sm"
              data-testid="invite-login-btn"
            >
              Entrar
            </button>
          </div>
        ) : status === "done" ? (
          <p className="text-sm text-muted">Redirecionando…</p>
        ) : (
          <div>
            <p className="text-sm text-[var(--error)] mb-3">{error}</p>
            <button onClick={() => navigate("/dashboard")} className="btn-outline text-sm">Ir para o Dashboard</button>
          </div>
        )}
      </div>
    </div>
  );
}
